import tippy from "tippy.js"
import invariant from "tiny-invariant"
import onReady from "./onReady"

const bookMap: Record<string, string | undefined> = {
  Matt: "Matthew.html",
  Luke: "Luke.html",
  Malakai: "Malakai.html",
  Isaiah: "Isaiah.html",
  Jer: "Jeremiah.html",
  Jeremiah: "Jeremiah.html",
  Genesis: "Genesis.html",
  Gen: "Genesis.html",
  Exod: "Exodus.html",
  Exodus: "Exodus.html",
  Lev: "Leviticus.html",
  Leviticus: "Leviticus.html",
  Levi: "Leviticus.html",
  Deut: "Deuteronomy.html",
  [encodeURIComponent("Köölfel")]: "Koolfel.html",
  Zekariah: "Zekariah.html",
  Zek: "Zekariah.html",
  Ezekiel: "Ezekiel.html",
  Hosea: "Hosea.html",
  Habakkuk: "Habakkuk.html",
  Proverbs: "Proverbs.html",
  "1 Samuel": "1 Samuel.html",
  "2 Samuel": "2 Samuel.html",
  "1 Kronika": "1 Kronika.html",
  "2 Kronika": "2 Kronika.html",
  "1 King": "1 King.html",
  Job: "Job.html",
  Mika: "Mika.html",
  Hakkai: "Hakkai.html",
  Joshua: "Joshua.html",
  Joel: "Joel.html",
  Amos: "Amos.html",
  Num: "Numbers.html",
  Numbers: "Numbers.html",
  Ezek: "Ezekiel.html",
}

// Format an extracted link reference
let page: undefined | string
function formatLink(reference: string, book: string | undefined, chapter: string) {
  if (book) page = bookMap[encodeURIComponent(book)] ?? bookMap[book]
  invariant(page !== undefined, `${book} is not defined in the bookMap from ${reference}`)

  return `<a href="${page}#ch-${chapter}">${reference}</a>`
}

// Extract links
export function linkReferences(note: string | undefined): undefined | string {
  if (note === undefined) return
  const withLinks = note.replace(
    /(?:((?:\d )?\p{Letter}+)\.? )?(\d+):(\d+(?:[-,]\d+)*)/gu,
    formatLink
  )
  page = undefined
  return withLinks
}

onReady(() => {
  document.querySelectorAll("[data-footnote] > button").forEach(element => {
    const htmlElement = element as HTMLElement
    const content = linkReferences(htmlElement.dataset.note)
    invariant(content !== undefined, `No note in ${htmlElement.textContent}`)
    tippy(htmlElement, {
      content,
      interactive: true,
      offset: [0, -12],
      allowHTML: true,
    })
  })
})
